import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Package, Truck, Images } from "lucide-react";

export const Route = createFileRoute("/admin/")({
  component: AdminIndex,
});

function AdminIndex() {
  const [stats, setStats] = useState({ products: 0, orders: 0, slides: 0 });

  useEffect(() => {
    (async () => {
      const [p, o, s] = await Promise.all([
        supabase.from("products").select("id", { count: "exact", head: true }),
        supabase.from("orders").select("id", { count: "exact", head: true }),
        supabase.from("hero_slides").select("id", { count: "exact", head: true }),
      ]);
      setStats({ products: p.count ?? 0, orders: o.count ?? 0, slides: s.count ?? 0 });
    })();
  }, []);

  const cards = [
    { to: "/admin/products", label: "Products", count: stats.products, icon: Package },
    { to: "/admin/orders", label: "Order Tracking", count: stats.orders, icon: Truck },
    { to: "/admin/slides", label: "Hero Slides", count: stats.slides, icon: Images },
  ] as const;

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {cards.map((c) => (
        <Link key={c.to} to={c.to} className="rounded-lg border border-border p-6 hover:bg-muted transition-colors">
          <c.icon className="h-6 w-6 text-primary mb-3" />
          <p className="text-sm text-muted-foreground">{c.label}</p>
          <p className="text-3xl display mt-1">{c.count}</p>
        </Link>
      ))}
    </div>
  );
}
